import templateUrl from "./filter.html";
import './filter.scss';

export const filterComponent = {
  bindings: {
    viewType: "@",
    filterObj: "<",
    filterData: "&",
    defaultSelectedOptionId: "@",
  },

  templateUrl,

  controller: class FilterComponent {
    constructor($scope, $state) {
      "ngInject";
      this.$state = $state;
      this.$scope = $scope;
      this.dataArray = [];
      this.name = new Date().getTime() + Math.random();
    }

    $onInit() {
      const thisScope = this;
      this.$scope.$on("backDropClick", function (e) {     
        thisScope.filterObj = thisScope.filterObj.map((list) => {
          list.isOpen = false;
          return list;
        });
      });
    }

    //function to return rangepicker change values
    onRangeSliderChange(details, key) {
      this.passData(key, details);
    }

    //function to return filtered data from multilevelCheckbox component
    onMultilevelCheckboxChange(details, key) {
      this.passData(key, details);
    }

    _onChangeRadio(filter, option) {
      this.passData(filter.key, option.sendKey);
    }

    passData(key, data) {
      this.dataArray[key] = data;
      this.filterData({
        details: this.dataArray,
        currentObj: {
          key: key,
          data: data,
        },
      });
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/common/components/filter/filter.component.js